import * as React from "react";
const ICelebrateArt = () => {
  return (
    <svg
      width="240"
      height="180"
      viewBox="0 0 240 180"
      fill="none"
    >
      <mask id="path-1-inside-1_1616_10511" fill="white">
        <path d="M0.206055 0H239.794V180H0.206055V0Z" />
      </mask>
      <path
        d="M0.206055 0H239.794V180H0.206055V0Z"
        fill="url(#paint0_radial_1616_10511)"
        fill-opacity="0.65"
      />
      <path
        d="M239.794 179H0.206055V181H239.794V179Z"
        fill="url(#paint1_linear_1616_10511)"
        mask="url(#path-1-inside-1_1616_10511)"
      />
      <g clip-path="url(#clip0_1616_10511)">
        <path
          d="M113.515 17.1017C113.515 17.1017 125.163 0.126143 139.731 8.59097C157.968 19.1921 135.948 44.4258 149.425 51.7306C162.901 59.0354 176.849 59.6096 180.735 79.8126C185.806 106.229 137.984 143.362 97.5319 119.851C57.0802 96.3403 71.4764 52.3393 90.4719 43.5759C113.319 33.0436 113.515 17.1017 113.515 17.1017Z"
          fill="#1B1211"
        />
        <path
          d="M130.119 62.1592V80.2718C130.216 81.7643 130.005 83.2607 129.5 84.6686C128.995 86.0765 128.206 87.366 127.183 88.4572C126.159 89.5485 124.922 90.4183 123.548 91.013C122.174 91.6076 120.693 91.9144 119.195 91.9144C117.698 91.9144 116.217 91.6076 114.843 91.013C113.469 90.4183 112.232 89.5485 111.208 88.4572C110.184 87.366 109.395 86.0765 108.89 84.6686C108.385 83.2607 108.175 81.7643 108.272 80.2718V62.1592H130.119Z"
          fill="#E88C7B"
        />
        <path
          d="M84.3202 49.7438C84.644 51.3309 85.4319 52.7865 86.584 53.9264C87.7361 55.0662 89.2008 55.8392 90.7928 56.1476C92.3847 56.4559 94.0324 56.2858 95.5275 55.6586C97.0227 55.0315 98.2981 53.9756 99.1924 52.6244C100.087 51.2732 100.56 49.6875 100.552 48.0677C100.544 46.4479 100.055 44.8669 99.1474 43.5246C98.2398 42.1823 96.9541 41.139 95.4528 40.5267C93.9515 39.9143 92.3021 39.7605 90.7133 40.0845C88.5849 40.5217 86.7168 41.7839 85.5184 43.5945C84.32 45.4051 83.8891 47.6164 84.3202 49.7438Z"
          fill="#E88C7B"
        />
        <path
          d="M96.6235 36.0302V49.8128C96.6235 49.8128 91.1387 44.9429 91.2882 35.3525L96.6235 36.0302Z"
          fill="#1B1211"
        />
        <path
          d="M86.574 46.6426L93.0706 51.03"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M131.798 48.1018C132.124 49.6882 132.914 51.1423 134.068 52.2802C135.222 53.4181 136.687 54.1887 138.28 54.4946C139.872 54.8005 141.519 54.628 143.013 53.9988C144.507 53.3696 145.781 52.312 146.673 50.9597C147.566 49.6075 148.036 48.0213 148.026 46.4017C148.016 44.7822 147.526 43.202 146.616 41.861C145.707 40.52 144.42 39.4784 142.919 38.8678C141.417 38.2573 139.767 38.1053 138.179 38.431C137.124 38.6473 136.123 39.0691 135.231 39.6722C134.339 40.2753 133.575 41.0479 132.983 41.946C132.39 42.844 131.981 43.8499 131.777 44.9061C131.574 45.9623 131.581 47.0482 131.798 48.1018Z"
          fill="#E88C7B"
        />
        <path
          d="M139.824 46.4587C139.824 46.4587 144.515 41.3362 142.871 29.2305H136.293L139.824 46.4587Z"
          fill="#1B1211"
        />
        <path
          d="M138.478 50.0771L144.837 43.9209"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M118.229 14.4492C112.499 14.4492 107.003 16.723 102.951 20.7702C98.8996 24.8175 96.6233 30.3068 96.6233 36.0305V51.7427C96.6238 53.3758 97.0398 54.982 97.8323 56.4104C98.6248 57.8389 99.7677 59.0427 101.154 59.9089L113.112 67.386C114.647 68.3434 116.42 68.851 118.229 68.851C120.038 68.851 121.811 68.3434 123.346 67.386L135.304 59.9089C136.689 59.0421 137.83 57.8379 138.621 56.4093C139.411 54.9808 139.825 53.3749 139.823 51.7427V36.0305C139.825 33.197 139.267 30.3909 138.183 27.7726C137.098 25.1543 135.508 22.7751 133.502 20.7709C131.497 18.7668 129.116 17.1769 126.495 16.0922C123.875 15.0075 121.066 14.4492 118.229 14.4492Z"
          fill="#E88C7B"
        />
        <path
          d="M108.203 64.5137L113.078 67.5573C114.611 68.52 116.384 69.0307 118.195 69.0307C120.005 69.0307 121.779 68.52 123.312 67.5573"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M116.413 14.4492L121.84 51.7427H115.033"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M138.869 46.9992C138.869 48.0918 138.545 49.1599 137.937 50.0684C137.329 50.9769 136.466 51.685 135.455 52.1032C134.444 52.5213 133.332 52.6307 132.259 52.4175C131.187 52.2044 130.201 51.6782 129.428 50.9056C128.654 50.133 128.127 49.1486 127.914 48.0769C127.7 47.0053 127.81 45.8945 128.229 44.885C128.647 43.8755 129.356 43.0127 130.266 42.4057C131.175 41.7986 132.245 41.4746 133.338 41.4746C134.065 41.4731 134.785 41.615 135.457 41.8921C136.128 42.1692 136.739 42.576 137.253 43.0893C137.767 43.6026 138.174 44.2123 138.451 44.8832C138.729 45.5542 138.871 46.2732 138.869 46.9992Z"
          fill="#E6715C"
        />
        <path
          d="M109.444 46.9992C109.444 48.0918 109.12 49.1599 108.512 50.0684C107.905 50.9769 107.041 51.685 106.03 52.1032C105.02 52.5213 103.907 52.6307 102.835 52.4175C101.762 52.2044 100.776 51.6782 100.003 50.9056C99.2293 50.133 98.7025 49.1486 98.4891 48.0769C98.2757 47.0053 98.3852 45.8945 98.8038 44.885C99.2224 43.8755 99.9313 43.0127 100.841 42.4057C101.75 41.7986 102.82 41.4746 103.914 41.4746C104.64 41.4731 105.36 41.615 106.032 41.8921C106.704 42.1692 107.314 42.576 107.828 43.0893C108.342 43.6026 108.749 44.2123 109.026 44.8832C109.304 45.5542 109.446 46.2732 109.444 46.9992Z"
          fill="#E6715C"
        />
        <path
          d="M128.21 45.1838C129.264 45.1838 130.119 43.636 130.119 41.7267C130.119 39.8173 129.264 38.2695 128.21 38.2695C127.156 38.2695 126.301 39.8173 126.301 41.7267C126.301 43.636 127.156 45.1838 128.21 45.1838Z"
          fill="#1B1211"
        />
        <path
          d="M110.146 41.7269C110.146 43.6335 109.295 45.1726 108.237 45.1726C107.179 45.1726 106.328 43.622 106.328 41.7269C106.328 39.8318 107.191 38.2812 108.237 38.2812C109.284 38.2812 110.146 39.8203 110.146 41.7269Z"
          fill="#1B1211"
        />
        <path
          d="M143.48 11.52C128.911 3.05517 113.503 17.102 113.503 17.102C113.503 17.102 113.319 33.0438 90.5063 43.5761C85.6884 45.7928 79.2263 53.7063 76.2021 58.5072C76.2021 58.5072 82.8828 39.269 84.987 26.8302C87.0912 14.3914 98.1413 16.3439 98.1413 16.3439C98.1413 16.3439 104.856 -0.0459241 123.438 0.0344745C136.282 0.0574455 143.48 11.52 143.48 11.52Z"
          fill="#322A28"
        />
        <path
          d="M126.796 27.5081C128.52 24.878 130.245 24.5564 131.315 28.0709L126.796 27.5081Z"
          fill="#1B1211"
        />
        <path
          d="M103.132 28.5073C103.385 25.3603 104.707 24.2806 107.363 26.8304L103.132 28.5073Z"
          fill="#1B1211"
        />
        <path
          d="M111.79 54.4414L125.082 55.3832C125.082 55.3832 123.817 60.4713 119.747 61.126C118.777 61.2563 117.79 61.1827 116.85 60.9099C115.91 60.6371 115.038 60.171 114.288 59.5417C113.539 58.9123 112.93 58.1335 112.5 57.2552C112.069 56.3769 111.828 55.4185 111.79 54.4414Z"
          fill="white"
        />
        <path
          d="M119.713 57.6574L112.813 57.4277"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M187.542 149.657C186.509 150.538 185.311 151.208 184.019 151.628C182.726 152.047 181.363 152.208 180.008 152.101C178.653 151.995 177.332 151.622 176.122 151.006C174.911 150.389 173.833 149.541 172.951 148.508L139.455 109.607C138.573 108.574 137.902 107.378 137.482 106.087C137.062 104.796 136.901 103.435 137.008 102.081C137.115 100.728 137.487 99.4084 138.105 98.1988C138.722 96.9893 139.572 95.913 140.605 95.0314C141.639 94.1497 142.836 93.48 144.129 93.0605C145.421 92.641 146.784 92.48 148.139 92.5866C149.494 92.6933 150.815 93.0655 152.026 93.6821C153.237 94.2986 154.314 95.1474 155.197 96.18L190.014 137.39C190.014 137.39 191.854 145.947 187.542 149.657Z"
          fill="#E88C7B"
        />
        <path
          d="M171.64 104.449L153.99 113.58L139.617 130.177L157.911 120.081L171.64 104.449Z"
          fill="#B45458"
        />
        <path
          d="M154.795 89.8515L172.721 112.558L148.171 132.348L132.073 105.414C131.063 103.729 130.424 101.847 130.201 99.895C129.977 97.943 130.175 95.9658 130.779 94.096C131.383 92.2263 132.381 90.5073 133.705 89.0541C135.029 87.601 136.648 86.4474 138.455 85.6707C141.258 84.4645 144.382 84.2205 147.339 84.977C150.295 85.7335 152.917 87.4477 154.795 89.8515Z"
          fill="#F27376"
        />
        <path
          d="M171.64 104.449L157.911 120.081L139.617 130.177L149.091 138.113L164.304 127.822L177.803 112.581L171.64 104.449Z"
          fill="white"
        />
        <path
          d="M205.94 106.459L192.763 145.441C192.229 147.012 191.355 148.446 190.202 149.64C189.049 150.835 187.646 151.759 186.094 152.349C184.541 152.938 182.878 153.177 181.222 153.049C179.566 152.921 177.959 152.429 176.515 151.609C174.076 150.239 172.238 148.008 171.363 145.353C170.489 142.698 170.641 139.812 171.789 137.263C178.596 122.47 190.187 114.522 198.673 98.3848L205.94 106.459Z"
          fill="#E88C7B"
        />
        <path
          d="M195.913 103.933L196.58 96.5476C198.408 91.5973 205.181 84.752 205.181 84.752L207.86 88.0483C222.015 99.4534 205.123 108.412 205.123 108.412L195.913 103.933Z"
          fill="#E88C7B"
        />
        <path
          d="M201.179 89.1393L211.218 99.5796L212.781 99.9357C215.472 96.8001 218.036 91.7809 212.586 87.1178C211.438 86.1474 210.18 85.3148 208.837 84.637C204.629 81.4555 201.179 89.1393 201.179 89.1393Z"
          fill="#E88C7B"
        />
        <path
          d="M206.779 102.485C211.31 95.4446 203.974 90.5862 203.974 90.5862L204.79 84.1084"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M207.228 94.1127C208.518 93.3019 209.623 92.2298 210.473 90.9656C211.323 89.7014 211.898 88.2733 212.16 86.7734"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M205.25 91.93C207.076 89.8623 208.315 87.3441 208.838 84.6367"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M212.839 99.9357L208.665 97.4203C208.665 97.4203 214.092 95.1232 215.07 90.0352"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M196.58 96.5473C196.58 96.5473 197.914 89.7593 190.279 85.8083L191.176 84.9469C191.645 84.4856 192.25 84.1865 192.902 84.0934C193.554 84.0004 194.218 84.1184 194.798 84.4301C197.436 85.7106 199.783 87.5164 201.697 89.7364L196.58 96.5473Z"
          fill="#E88C7B"
        />
        <path
          d="M27.2187 133.071C25.5145 130.928 24.7306 128.198 25.0389 125.478C25.3471 122.759 26.7223 120.273 28.863 118.565L69.1077 86.566C71.2537 84.8602 73.9898 84.075 76.715 84.3829C79.4402 84.6909 81.9316 86.0668 83.6419 88.2084C85.3496 90.352 86.1357 93.0851 85.8274 95.8072C85.5191 98.5293 84.1416 101.018 81.9976 102.726L41.8103 134.725C40.7454 135.578 39.5221 136.212 38.2108 136.59C36.8995 136.969 35.5261 137.085 34.1699 136.931C32.8136 136.777 31.5012 136.357 30.3082 135.695C29.1152 135.032 28.0652 134.14 27.2187 133.071Z"
          fill="#E88C7B"
        />
        <path
          d="M137.869 163.209H96.4739L73.3274 90.1615C72.643 87.95 72.58 85.5931 73.1452 83.3482C73.7105 81.1034 74.8823 79.0568 76.5328 77.4319C78.1833 75.807 80.2489 74.6662 82.5043 74.1342C84.7596 73.6021 87.118 73.6992 89.3219 74.4148L121.886 85.2572L143.79 84.6025C145.619 84.5479 147.435 84.9227 149.092 85.6967C150.749 86.4707 152.202 87.6223 153.332 89.0589C154.463 90.4955 155.241 92.177 155.602 93.9683C155.964 95.7597 155.9 97.6108 155.415 99.3728L137.869 163.209Z"
          fill="#F27376"
        />
        <path
          d="M132.51 95.1692L135.592 74.8972L100.763 71.5205L104.006 95.1692H132.51Z"
          fill="#F27376"
        />
        <path
          d="M88.1721 150.472L145.688 147.348L140.651 161.911L92.76 161.394L88.1721 150.472Z"
          fill="#604EA0"
        />
        <path
          d="M140.651 161.911C140.651 161.911 160.348 180.104 161.521 212.563H73.4082C73.4082 182.057 92.7602 161.395 92.7602 161.395L140.651 161.911Z"
          fill="#604EA0"
        />
        <path
          d="M118.045 165.196L119.195 189.316C119.195 189.316 114.504 187.421 114.596 179.346"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M151.207 175.314H136.949C136.949 175.314 143.606 190.854 157.75 189.488"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M75.5122 191.728C75.5122 191.728 86.0563 194.255 95.3931 179.301"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M104.362 159.431H94.3928V164.404H104.362V159.431Z"
          fill="#010101"
        />
        <path
          d="M138.156 159.431H128.187V164.404H138.156V159.431Z"
          fill="#010101"
        />
        <path
          d="M124.14 159.431H108.996V164.404H124.14V159.431Z"
          fill="#010101"
        />
        <path
          d="M120.288 158.431H112.848V165.414H120.288V158.431Z"
          fill="white"
        />
        <path
          d="M30.3349 117.336C33.272 115.504 36.8174 114.911 40.1918 115.688C43.5663 116.466 46.4935 118.55 48.33 121.483L74.3167 168.183L66.3597 177.371L26.1954 135.288C24.3668 132.358 23.7757 128.823 24.5516 125.458C25.3275 122.093 27.4072 119.173 30.3349 117.336Z"
          fill="#E88C7B"
        />
        <path
          d="M71.0741 165.334C81.5952 165.334 91.116 159.993 91.116 159.993L97.0262 178.45C79.7095 185.009 70.9476 180.69 66.3252 177.417L71.0741 165.334Z"
          fill="#E88C7B"
        />
        <path
          d="M91.1157 159.993C91.1157 159.993 100.809 159.132 107.743 163.703L108.996 175.189C108.996 175.189 100.947 172.547 95.7151 174.304C95.7151 174.304 104.661 176.004 108.134 179.76L105.684 182.241C100.591 180.156 95.06 179.366 89.5864 179.944L91.1157 159.993Z"
          fill="#E88C7B"
        />
        <path
          d="M107.984 166.644C107.984 166.644 99.935 164.025 93.8293 163.853"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M108.547 171.146C103.914 169.416 98.9787 168.635 94.0364 168.849"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M57.8276 83.3965L71.3729 97.9257L79.2953 118.393L65.4741 102.727L57.8276 83.3965Z"
          fill="#B45458"
        />
        <path
          d="M77.4441 76.5625L54.0791 90.6323L70.5105 117.6L85.838 107.148L77.4441 76.5625Z"
          fill="#F27376"
        />
        <path
          d="M57.8276 83.3965L65.4741 102.727L79.2953 118.393L67.6933 122.677L56.8502 107.872L49.2842 88.9784L57.8276 83.3965Z"
          fill="white"
        />
        <path
          d="M51.5724 127.317L48.3298 121.482"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M134.902 97.3393C133.991 97.3206 133.085 97.486 132.24 97.8256C131.394 98.1653 130.626 98.6722 129.982 99.3159C129.337 99.9596 128.83 100.727 128.49 101.571C128.15 102.416 127.984 103.321 128.003 104.231C128.044 106.561 128.984 108.785 130.627 110.439C132.27 112.094 134.49 113.05 136.822 113.109C141.698 113.109 144.572 108.836 143.422 104.231C142.928 102.313 141.827 100.607 140.284 99.3652C138.74 98.1235 136.837 97.4129 134.856 97.3393M138.501 99.7168C138.605 99.7168 138.685 99.7168 138.766 99.8317C139.218 100.169 139.578 100.616 139.812 101.13C139.927 101.336 139.915 101.463 139.731 101.543C139.547 101.623 139.49 101.761 139.363 101.738C139.237 101.715 139.202 101.497 139.122 101.371C138.779 100.871 138.351 100.436 137.857 100.084L137.731 99.9925C137.972 99.8891 138.26 99.8432 138.513 99.7513M131.245 105.218C131.128 105.445 131.058 105.694 131.04 105.949C131.023 106.203 131.057 106.459 131.142 106.7L130.326 106.401C130.287 106.396 130.252 106.376 130.226 106.347C130.201 106.317 130.187 106.28 130.188 106.241C130.101 105.778 130.145 105.301 130.314 104.862C130.314 104.759 130.395 104.725 130.51 104.77L131.2 105.058C131.28 105.058 131.292 105.138 131.2 105.218M141.548 106.608C141.556 106.731 141.526 106.852 141.462 106.957C141.399 107.062 141.304 107.145 141.192 107.194C141.056 107.275 140.901 107.314 140.743 107.309C140.61 107.31 140.478 107.274 140.364 107.205C140.252 107.139 140.164 107.038 140.112 106.919C140.061 106.799 140.048 106.666 140.076 106.539C139.801 106.163 139.472 105.83 139.099 105.551C139.198 106.118 139.198 106.697 139.099 107.263C139.001 107.718 138.826 108.153 138.582 108.549C138.371 108.892 138.093 109.189 137.765 109.422C137.484 109.63 137.174 109.797 136.845 109.916C136.395 110.083 135.922 110.184 135.442 110.215C135.014 110.241 134.584 110.182 134.178 110.042C133.776 109.898 133.417 109.658 133.131 109.342C132.797 108.986 132.542 108.563 132.384 108.101C132.147 107.588 132.048 107.022 132.096 106.459C132.133 105.995 132.288 105.549 132.545 105.161C132.8 104.786 133.124 104.462 133.499 104.208C133.91 103.94 134.355 103.728 134.822 103.576C135.441 103.369 136.089 103.264 136.742 103.266C136.409 102.574 135.832 102.029 135.12 101.738C134.25 101.481 133.323 101.481 132.453 101.738C132.264 101.785 132.067 101.785 131.878 101.738C131.776 101.723 131.681 101.677 131.606 101.608C131.53 101.538 131.476 101.448 131.452 101.348C131.418 101.276 131.4 101.198 131.4 101.118C131.4 101.039 131.418 100.96 131.452 100.888C131.604 100.719 131.805 100.602 132.027 100.555C132.77 100.316 133.547 100.199 134.327 100.211C134.945 100.229 135.553 100.378 136.109 100.647C136.653 100.922 137.128 101.315 137.501 101.796C137.94 102.348 138.293 102.964 138.547 103.622C139.087 103.843 139.588 104.149 140.03 104.529C140.459 104.886 140.844 105.291 141.18 105.735C141.388 105.986 141.527 106.287 141.583 106.608M136.374 104.667C136.055 104.682 135.739 104.732 135.431 104.816C135.158 104.911 134.896 105.034 134.649 105.184C134.429 105.327 134.238 105.51 134.086 105.724C133.946 105.93 133.855 106.166 133.821 106.413C133.789 106.685 133.825 106.961 133.925 107.217C134.075 107.669 134.391 108.047 134.81 108.274C135.016 108.365 135.24 108.413 135.465 108.413C135.691 108.413 135.915 108.365 136.121 108.274C136.391 108.179 136.64 108.035 136.857 107.849C137.085 107.636 137.266 107.378 137.386 107.091C137.521 106.755 137.587 106.396 137.581 106.034C137.585 105.581 137.516 105.131 137.374 104.702C137.047 104.624 136.709 104.597 136.374 104.621M135.454 107.24C135.311 107.235 135.174 107.179 135.068 107.082C134.963 106.985 134.896 106.854 134.879 106.711C134.869 106.647 134.873 106.58 134.891 106.517C134.909 106.454 134.94 106.396 134.983 106.345C135.025 106.295 135.078 106.255 135.138 106.227C135.197 106.199 135.262 106.184 135.328 106.183C135.471 106.188 135.608 106.244 135.713 106.341C135.819 106.438 135.886 106.569 135.902 106.711C135.914 106.777 135.912 106.844 135.895 106.908C135.877 106.972 135.846 107.031 135.803 107.082C135.76 107.132 135.707 107.173 135.646 107.2C135.586 107.227 135.52 107.241 135.454 107.24Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_1616_10511"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(120 180) rotate(90) scale(78.2279 104.125)"
        >
          <stop stop-color="#A48AFF" stop-opacity="0" />
          <stop offset="1" stop-color="white" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_1616_10511"
          x1="0.206055"
          y1="180"
          x2="239.794"
          y2="180"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.5" stop-color="#604EA0" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <clipPath id="clip0_1616_10511">
          <rect
            width="191.588"
            height="180"
            fill="white"
            transform="translate(24.2061)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ICelebrateArt;
